<template>
  <dashboard-layout>
    <div class="container-fluid">
      <div class="col-md-6">
        <router-link to="/netpay" class="icon text-gray-600">
        <i class="fas fa-arrow-left"></i> Back
        </router-link>
    </div>
      <div class="card shadow mb-4">
        <div class="card-body">
          <div class="col-md-6">
           
           <h6 class="m-0 font-weight-bold text-dark">Settlement Reprocess</h6><br>
         </div>
          <div class="card-body justify-content-between"> 
            
         
          <div class="row mb-3">
            <div class="col-md-6">
                <label for="startDate">Start Date</label>
                <vue-date-picker v-model="startDate" id="startDate" placeholder="Select start date"></vue-date-picker>
              </div>
              <div class="col-md-6">
                <label for="endDate">End Date</label>
                <vue-date-picker v-model="endDate" id="endDate" placeholder="Select end date"></vue-date-picker>
              </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="searchInput">MerchantRef</label>
              <input v-model="MerchantRef" type="text" class="form-control" id="searchInput" placeholder="Enter MerchantRef">
          </div>
          <br>
          <div class="col-md-6">
              <label for="searchInput">TransactionRef</label>
              <input v-model="TransactionRef" type="text" class="form-control" id="searchInput" placeholder="Enter TransactionRef">
          </div>
          </div>

          <div class="row mb-3">

          <div class="d-flex">
  
             
              <button @click="fetchRecords" class="btn btn-primary btn-icon-split mr-3" :disabled="isSearchDisabled()">
                <span class="icon text-white-600">
                  <i class="fas fa-search"></i> 
                </span>
                <span class="text">Search</span> 
              </button>

              <div v-if="startDate && endDate">
              <label for="recordLimit" class="mr-2">Count</label>
            <select v-model="pageSize" id="recordLimit" class="form-control custom-select mr-5">
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
        
            </select>
            </div>
  
     
            <router-link to="/view-transactions" class="icon text-gray-600 ">
              <button class="btn btn-success btn-icon-split ">
                <span class="icon text-white-600">
                  <i class="fas fa-eye"></i> 
                </span>
                <span class="text">View Transactions</span> 
              </button>
            </router-link>

        
        
           </div>
          </div>
          <div v-if="isLoading" class="text-center">
            <i class="fas fa-spinner fa-spin fa-3x"></i> 
            <p>Fetching Records...</p>
          </div>
          <div v-else>
            <div class="card-body">
            <div class="table-responsive" v-if="reprocessedRecords.length > 0">
              <table class="table table-bordered" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th>PaymentDate</th>
                    <th>PaymentRef</th>
                    <th>CustomerID</th>
                    <th>MerchantRef</th>
                    <th>TransactionRef</th>
                    <th>Amount</th>
                    <th>Settlement_Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                 
                  <tr v-for="(record, index) in displayedRecords" :key="index">
                    <td>{{ record.FormattedTimestamp }}</td>
                    <td>{{ record.PaymentRef }}</td>
                    <td>{{ record.CustomerID }}</td>
                    <td>{{ record.MerchantRef }}</td>
                    <td>{{ record.TransactionRef }}</td>
                    <td>{{ formatAmount(record.Amount) }}</td>
                    <td :style="getSettlementStatusStyle(record.SettlementStatus)">
                      <i v-if="record.isLoading === false" class="fas fa-spinner fa-spin" style="color: #333;"></i>
                      <i v-else-if="Isloading === true">{{ record.SettlementStatus }}</i>
                    </td>
                    <td>
                      <i v-if="record.isLoading === false" class="fas fa-spinner fa-spin" style="color: #333;"></i> 
              <i v-else-if="record.SettlementStatus === 'Settled'"
                class="fas fa-check-circle"
                style="color: green;"
                v-b-tooltip.hover title="Successful"> 
              </i>
              <i
                v-else-if="record.SettlementStatus === 'Reprocessed'"
                class="fas fa-sync-alt"
                style="color: grey;"
                v-b-tooltip.hover title="Reprocessed"
                disabled="true">
              </i>
              <i v-else-if="record.SettlementStatus === 'Not Settled' && !reprocessed[index]"
                class="fas fa-sync-alt"
                style="color: black;"
                v-b-tooltip.hover title="Reprocess"
                @click="handleReprocess(index, record.MerchantRef)"> 
            </i>
            <i v-else-if="['Settlement is still Processing', 'Trxn Not Found','Request Timed Out, Please Refresh'].includes(record.SettlementStatus)"
                class="fas fa-times"
                style="color: red;"
                v-b-tooltip.hover title="Not Found"> 
            </i>
            </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
            <div class="table-responsive" v-if="reprocessedRecords.length == 0">
                <center>No Record Found</center>
                </div>


              <br>
                
              <ul class="pagination">
                <li :class="{ 'disabled': pageNumber === 1 }">
                  <a @click="pageNumber > 1 ? pageNumber-- : null">&laquo;</a>
                </li>
                <li v-for="pageNumber in totalPages" :key="pageNumber" :class="{ 'active-page': pageNumber === currentPage }">
                  <a @click="changePage(pageNumber)" class="page-number">{{ pageNumber }}</a>
                </li>
                <li :class="{ 'disabled': currentPage === totalPages }">
                  <a @click="pageNumber < totalPages ? pageNumber++ : null">&raquo;</a>
                </li>
              </ul>
           
          </div>
          
          </div>
        </div>
      </div>
    </div>
  </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/components/DashboardLayout.vue';
import axios from 'axios';

let logData; 



export default {
  name: 'view-reprocessed-records',

  components: {
    DashboardLayout,
  },

  data() {
    return {
      showSuccessMessage: false,
      errorMessage: '',
      reprocessedRecords: [], 
      startDate: null, 
      endDate: null,
      MerchantRef: '', 
      TransactionRef: '',  
      reprocessed: [],
      currentPage: 1,
      pageSize: 5,
      Isloading: false,
      isLoading: true,
      inputRequiredMessage: '',
    };
  },

  computed: {

    displayedRecords() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;
  return this.reprocessedRecords.slice(start, end);
},
  totalPages() {
    return Math.ceil(this.reprocessedRecords.length / this.pageSize);
  },

},

  async created() {
    try{

    await this.fetchDefaultRecords();
    this.reprocessedRecords = this.reprocessedRecords.map(record => ({ ...record, Isloading: false }));
    this.isLoading = false;
  }catch (error) {
          console.error(error);
          this.isLoading = false; 
          this.$toast.open({
          message: error,
          type: 'error',
          duration: 3000,
          });
          }
  },

  watch: {
  pageSize: 'fetchRecords', 
},

  methods: {

    formatAmount(amount) {
 
      const amountWithDecimals = Number(amount) / 100;


      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return formatter.format(amountWithDecimals);
    },


    isSearchDisabled() {
  return !(
    (this.MerchantRef && this.MerchantRef.length > 0) ||
    (this.TransactionRef && this.TransactionRef.length > 0) ||
    (this.startDate) ||
    (this.endDate)
  );
},


    isDateRangeValid() {
  if (this.isDateRangeSelected) {
    if (!this.startDate || !this.endDate) {
      this.inputRequiredMessage = 'Both start and end dates are required.';
      return false;
    } else if (this.startDate > this.endDate) {
      this.inputRequiredMessage = 'End date cannot be earlier than the start date.';
      return false;
    }
  }
  this.inputRequiredMessage = '';
  return true;
},




    changePage(pageNumber) {
    this.currentPage = pageNumber;
   
  },
      async fetchDefaultRecords() {
        const token = sessionStorage.getItem('token');
try {
  this.errorMessage = ''; 
  const headers = {
    'Authorization': `Bearer ${token}`,
  };


  const response = await axios.get(this.$config.GETNETPAYTRANSACTION_ENDPOINT,{ headers: headers });

  if (response.status === 200) {
    
    this.reprocessedRecords = response.data;

 
    for (let i = 0; i < this.reprocessedRecords.length; i++) {
      const merchantRef = this.reprocessedRecords[i].MerchantRef; 
      const statusResponse = await axios.post(this.$config.CHECKSETTELEMTSTATUS_ENDPOINT, {
        MerchantRef: merchantRef,
      },{headers}
      );
      this.reprocessedRecords[i].SettlementStatus = statusResponse.data.response;
      this.Isloading = true;
    }
  } else {
    this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
    this.$toast.open({
          message: 'Failed to fetch reprocessed records. Please contact the system administrator.',
          type: 'error',
          duration: 3000,
          });
  }
} catch (error) {
  console.error('Error fetching records:', error);
  this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
  this.$toast.open({
          message: 'Error fetching records:', error,
          type: 'error',
          duration: 3000,
          });
}
},


async fetchRecords() {
  if (this.isSearchDisabled()) {
   
      this.$toast.error('At least one input is required.');
      return;
    }

    if (!this.isDateRangeValid()) {
     
      this.$toast.warning(this.inputRequiredMessage);
      return;
    }

    this.isLoading = true;
  const token = sessionStorage.getItem('token');
  try {
    this.errorMessage = ''; 
    let url = '';
    const headers = {
    'Authorization': `Bearer ${token}`,
  };

  
    if (!this.startDate && !this.endDate && !this.MerchantRef && !this.TransactionRef) {
      this.errorMessage = 'Please enter a date range (e.g., 2023-09-05 to 2023-09-06), MerchantRef, or TransactionRef.';
      return;
    }

    if (this.startDate && !this.endDate) {
      this.$toast.warning('Please select an End Date');
      return;
    }

  
    if (this.startDate && this.endDate) {
 
      const startDateStr = this.startDate.toISOString().split('T')[0];
      const endDateStr = this.endDate.toISOString().split('T')[0];

      url = `${this.$config.GETNETPAYTRANSACTION_ENDPOINT}?startDate=${startDateStr}&endDate=${endDateStr}`;
    } else if (this.MerchantRef) {
     
      url = `${this.$config.GETNETPAYTRANSACTION_ENDPOINT}?MerchantRef=${this.MerchantRef}`;
    } else if (this.TransactionRef) {
    
      url = `${this.$config.GETNETPAYTRANSACTION_ENDPOINT}?TransactionRef=${this.TransactionRef}`;
    }

    const response = await axios.get(url,{headers});

    if (response.status === 200) {
      
      this.isLoading = false;
      this.reprocessedRecords = response.data;

      
      for (let i = 0; i < this.reprocessedRecords.length; i++) {
        const merchantRef = this.reprocessedRecords[i].MerchantRef; 

        try {
          const statusResponse = await axios.post(this.$config.CHECKSETTELEMTSTATUS_ENDPOINT, {
            MerchantRef: merchantRef,
          },{headers}
          );

          this.isLoading = false;
          this.reprocessedRecords[i].SettlementStatus = statusResponse.data.response;
          this.Isloading = true;
          
        } catch (error) {
          console.error(`Error fetching Settlement Status for record with MerchantRef ${merchantRef}:`, error);
          this.$toast.open({
          message: `Error fetching Settlement Status for record with MerchantRef ${merchantRef}:`, error,
          type: 'error', 
          duration: 3000, 
        });
       
          this.reprocessedRecords[i].SettlementStatus = 'Error';
        }
      }
    } else {
      this.errorMessage = 'Failed to fetch reprocessed records. Please contact the system administrator.';
      this.$toast.open({
          message: `Failed to fetch reprocessed records. Please contact the system administrator.`,
          type: 'error', 
          duration: 3000, 
        });
    }
  } catch (error) {
    console.error('Error fetching reprocessed records:', error);
    this.$toast.open({
          message: `Failed to fetch reprocessed records. Please contact the system administrator.`,
          type: 'error', 
          duration: 3000, 
        });
  }
},


async handleReprocess(index, merchantRef) {
  

  this.reprocessedRecords[index].isLoading = false;
  const rowRecord = this.reprocessedRecords[index];
  const token = sessionStorage.getItem('token');
  const headers = {
    'Authorization': `Bearer ${token}`,
  };

  try {
    const response = await axios.post(this.$config.UPDATESETTLEMENT_ENDPOINT, {
      MerchantRef: merchantRef,
    },{headers});


    const payload = {
      RecordDate: rowRecord.DateCreated, 
      Receipt_Number: rowRecord.PaymentRef, 
      Payer_Name: rowRecord.CustomerID, 
      Payment_Reference: rowRecord.MerchantRef, 
      Invoice_Number: rowRecord.TransactionRef,
      Total_Amount: rowRecord.Amount.toString(), 
    };

    const addRecordResponse = await axios.post(this.$config.ADDREPROCESSEDRECORD_ENDPOINT, payload,{headers});

    if (response.status == 200 && addRecordResponse.status == 200) {

      logData = {
  UserID: sessionStorage.getItem('userId'),
  FName: sessionStorage.getItem('firstName'),
  LName: sessionStorage.getItem('lastName'),
  Email: sessionStorage.getItem('email'),
  Role: sessionStorage.getItem('role'),
  Department: sessionStorage.getItem('department'),
  ActionType: 'Settlement Reprocess',
  Activity: `Settlement for ${merchantRef} has been reprocessed successfully`,
  Category: 'Netpay',
  Timestamp: new Date().toISOString()
};

const token = sessionStorage.getItem('token');
const headers = {
  'Authorization': `Bearer ${token}`,
};


axios.post(this.$config.ADDACTIVITYLOG_ENDPOINT, logData, { headers })
  .then(response => {

    console.log(response);
  })
  .catch(error => {
 
    console.error(error);
    this.$toast.open({
        message: error,
        type: 'error', 
        duration: 3000, 
      });
  });

  
  this.$toast.open({
        message: `Settlement for ${merchantRef} has been reprocessed successfully`,
        type: 'success', 
        duration: 3000, 
      });

    } else {
      this.$toast.open({
        message: 'Failed to Reprocess. Please contact the system administrator.',
        type: 'warning', 
        duration: 3000, 
      });
    }

   
    this.reprocessedRecords[index].isLoading = true;
    this.reprocessedRecords[index].SettlementStatus = 'Reprocessed';

  
   
    this.reprocessed[index] = true;

    setTimeout(() => {
      this.showSuccessMessage = false;
    }, 2000);
    setTimeout(() => {
      this.errorMessage = false;
    }, 2000);
  } catch (error) {
    console.error('Error during reprocess:', error);
    this.$toast.open({
        message: 'Error during reprocess:', error,
        type: 'warning', 
        duration: 3000, 
      });
  }
},






    getSettlementStatusStyle(status) {
      let style = {
        color: 'black',
      }; 

      if (status === 'Settled') {
        style.color = 'green';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Not Settled') {
        style.color = 'red';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Settlement is still Processing') {
        style.color = 'purple';
        style['font-weight'] = 'bold'; 
      } else if (status === 'Reprocessed') {
        style.color = 'orange';
        style['font-weight'] = 'bold'; 
      }

      return style;
    },
  },
};
</script>

<style>
.custom-card {
  margin: 10px;
}

.custom-card-width {
  max-width: 900px;
  margin: 30px auto;
}

.custom-select {
  width: 60px; 
  padding: .375rem 0.75rem; 
  font-size: 14px; 
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 1500px; 
}

.pagination li {
    margin: 0 5px; 
}

.pagination li.ellipsis::before {
    content: '...';
    padding: 0 5px;
}
</style>
